export class PriceRuleMembershipModel {
    public priceRuleMembershipId: string;
    public membershipLevelCode: string;
    public excludeFlag: boolean;
    public displaySequence: number;
}